import React from 'react';

const Footer = () => {
    return (
      <footer className="app-footer">
        <span className="d-inline-block">Licenciado para Prefeitura Capela do Alto</span>
      </footer>
    );
  }
;

export default Footer;
